/**
 * Thư gửi kèm chứng từ — soạn sẵn nội dung, người dùng sửa trước khi gửi.
 *
 * Phần THUẦN: chỉ dựng tiêu đề và thân thư từ dữ liệu chứng từ. Việc gửi thật
 * nằm ở tầng khác và cần secret hòm thư; không có secret thì giao diện vẫn
 * dựng được thư nhưng nút gửi bị khoá — không giả vờ gửi được.
 */

export interface MailAccount { id: string; address: string; label?: string }

/** Đọc cấu hình hòm thư từ biến môi trường. Sai định dạng thì coi như CHƯA có. */
export function parseMailAccounts(raw: string | undefined): MailAccount[] {
  if (!raw?.trim()) return [];
  try {
    const parsed: unknown = JSON.parse(raw);
    if (!Array.isArray(parsed)) return [];
    return parsed.flatMap((a) => {
      const row = a as Partial<MailAccount>;
      // Thiếu id hoặc địa chỉ thì bỏ: một hòm thư nửa vời gửi đi là gửi sai.
      return row?.id && row?.address ? [{ id: String(row.id), address: String(row.address), label: row.label ? String(row.label) : undefined }] : [];
    });
  } catch {
    return [];
  }
}

export interface MailDocument {
  kind: "pi" | "sampleOrder";
  documentNo: string;
  customerName: string | null;
  date: string | null;
  /** Mã hàng trên chứng từ, để người nhận biết thư nói về cái gì. */
  productCodes: string[];
  customerPoNo?: string | null;
}

export interface MailDraft { subject: string; body: string }

/**
 * Dựng thư mẫu.
 *
 * `t` là hàm dịch của giao diện: thư phải theo ngôn ngữ người dùng đang dùng,
 * không nhét chữ cứng vào mã. Chỉ điền những gì CÓ trên chứng từ — thiếu ngày
 * hay thiếu khách thì bỏ dòng đó, không in ra "null" hay ngày hôm nay.
 */
export function buildMailDraft(
  t: (key: string, vars?: Record<string, string>) => string,
  doc: MailDocument,
): MailDraft {
  const subject = t(`mail.subject.${doc.kind}`, { documentNo: doc.documentNo });
  const lines = [
    t("mail.greeting", { customer: doc.customerName ?? "" }).trim(),
    "",
    t(`mail.intro.${doc.kind}`, { documentNo: doc.documentNo }),
  ];
  if (doc.date) lines.push(t("mail.line.date", { date: doc.date }));
  if (doc.customerPoNo) lines.push(t("mail.line.customerPo", { po: doc.customerPoNo }));
  if (doc.productCodes.length)
    lines.push(t("mail.line.products", { codes: doc.productCodes.join(", ") }));
  lines.push("", t("mail.closing"));
  return { subject, body: lines.join("\n") };
}
